import { CSSProperties } from 'react';
import brandclub_colors from '../colors/brandclubColors';

export type BrandclubCssProperties = CSSProperties & {
  '&::-webkit-scrollbar': CSSProperties;
  '&::-webkit-scrollbar-thumb': CSSProperties;
};

export type BrandclubStyleClasses = 'customScrollbar';
export const brandclubStyles: Record<BrandclubStyleClasses, BrandclubCssProperties> = {
  customScrollbar: {
    '&::-webkit-scrollbar': {
      height: 5,
      width: 5,
      backgroundColor: 'transparent',
      borderRadius: 20,
      position: 'absolute',
      zIndex: 99999,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: brandclub_colors.darkBlue1,
      borderRadius: 20,
    },
  },
} as const;
